import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    closingStockSummarySearchParams:{
        primaryFilter:{
            fromDate:'',
            toDate:'',
            searchReportingFor:1,
            searchReportForName:'Companywise',
            searchBranchIds:'',
            searchBranchNames:[],
            searchInvStoreIds:'',
            searchInvStoreNames:[],
            showItemValue:1,
            showItemValueName:'No',
            subTotalBy:1,
            subTotalByName:'No Subtotal',
            searchItemCategoryIds:'',
            searchItemCategoryNames:[],
            searchItemSubCategoryIds:'',
            searchItemSubCategoryNames:[],
            searchBrandIds:'',
            searchBrandNames:[],
            searchInvItemIds:'',
            searchInvItemNames:[],
        },
        showItemSNWise :false,
        showDefItems:true,
        showRepItems:true,
        showScrapItems:true,
        showOnlyTrItems:true,
        showOnlyActiveItems:true,
        showOnlyBranchMappedModelItems:true
    },
    closingStockSummaryLists:{
        isLoading:false,
        isLoadingMore:false,
        dataLoaded:false,
        data:null,
        totalRecords:0,
        recordCounts:0,
        pageNo:0,
        perPageRecords:2000,
        closingStockSummaryError:'',
        closingStockSummaryMoreError:''
    },
    loadClosingStockSummaryData: false,
    manageDefectiveandScrap:{
        forItemRow:null,
        forBranchId:null
    }
}

const reportClosingStockSummarySlice = createSlice({
    name: "reportClosingStockSummarySlice",
    initialState,
    reducers: {
        closingStockSummaryPrimaryFiltersUpdates: (state, {payload}) => {
            if(payload?.fromDate && payload?.fromDate !== ''){
                state.closingStockSummarySearchParams.primaryFilter.fromDate = payload.fromDate;
            }else if(payload?.fromDate === ''){
                state.closingStockSummarySearchParams.primaryFilter.fromDate = '';
            }
            
            if(payload?.toDate && payload?.toDate !== ''){
                state.closingStockSummarySearchParams.primaryFilter.toDate = payload.toDate;
            }else if(payload?.toDate === ''){
                state.closingStockSummarySearchParams.primaryFilter.toDate = '';
            }
            if(payload?.searchReportingFor && payload?.searchReportingFor > 0){
                state.closingStockSummarySearchParams.primaryFilter.searchReportingFor = payload.searchReportingFor;
                if(payload.searchReportingFor !== 1){
                    state.closingStockSummarySearchParams.showOnlyTrItems = true;
                }
            }else if(payload?.searchReportingFor === ''){
                state.closingStockSummarySearchParams.primaryFilter.searchReportingFor = '';
            }
            if(payload?.searchReportForName && payload?.searchReportForName !== ''){
                state.closingStockSummarySearchParams.primaryFilter.searchReportForName = payload.searchReportForName;
            }else if(payload?.searchReportingFor === ''){
                state.closingStockSummarySearchParams.primaryFilter.searchReportForName = '';
            }
            if(payload?.searchBranchIds && payload?.searchBranchIds !== ''){
                state.closingStockSummarySearchParams.primaryFilter.searchBranchIds = payload.searchBranchIds;
            }else if(payload?.searchBranchIds === ''){
                state.closingStockSummarySearchParams.primaryFilter.searchBranchIds = '';
            }
            if(payload?.searchBranchNames && payload?.searchBranchNames?.length > 0){
                state.closingStockSummarySearchParams.primaryFilter.searchBranchNames = payload.searchBranchNames;
            }else if(payload?.searchBranchNames?.length === 0){
                state.closingStockSummarySearchParams.primaryFilter.searchBranchNames = [];
            }
            if(payload?.searchInvStoreIds && payload?.searchInvStoreIds !== ''){
                state.closingStockSummarySearchParams.primaryFilter.searchInvStoreIds = payload.searchInvStoreIds;
            }else if(payload?.searchInvStoreIds === ''){
                state.closingStockSummarySearchParams.primaryFilter.searchInvStoreIds = '';
            }
            if(payload?.searchInvStoreNames && payload?.searchInvStoreNames?.length > 0){
                state.closingStockSummarySearchParams.primaryFilter.searchInvStoreNames = payload.searchInvStoreNames;
            }else if(payload?.searchInvStoreNames?.length === 0){
                state.closingStockSummarySearchParams.primaryFilter.searchInvStoreNames = [];
            }
            if(payload?.showItemValue && payload?.showItemValue !== ''){
                state.closingStockSummarySearchParams.primaryFilter.showItemValue = payload.showItemValue;
            }else if(payload?.showItemValue === ''){
                state.closingStockSummarySearchParams.primaryFilter.showItemValue = 1;
            }
            if(payload?.showItemValueName && payload?.showItemValueName !== ''){
                state.closingStockSummarySearchParams.primaryFilter.showItemValueName = payload.showItemValueName;
            }else if(payload?.showItemValueName === ''){
                state.closingStockSummarySearchParams.primaryFilter.showItemValueName = '';
            }
            if(payload?.subTotalBy && payload?.subTotalBy !== ''){
                state.closingStockSummarySearchParams.primaryFilter.subTotalBy = payload.subTotalBy;
            }else if(payload?.subTotalBy === ''){
                state.closingStockSummarySearchParams.primaryFilter.subTotalBy = 'N';
            }
            if(payload?.subTotalByName && payload?.subTotalByName !== ''){
                state.closingStockSummarySearchParams.primaryFilter.subTotalByName = payload.subTotalByName;
            }else if(payload?.subTotalByName === ''){
                state.closingStockSummarySearchParams.primaryFilter.subTotalByName = '';
            }

            if(payload?.searchItemCategoryIds && payload?.searchItemCategoryIds !== ''){
                state.closingStockSummarySearchParams.primaryFilter.searchItemCategoryIds = payload.searchItemCategoryIds;
            }else if(payload?.searchItemCategoryIds === ''){
                state.closingStockSummarySearchParams.primaryFilter.searchItemCategoryIds = '';
            }
            if(payload?.searchItemCategoryNames && payload?.searchItemCategoryNames?.length > 0){
                state.closingStockSummarySearchParams.primaryFilter.searchItemCategoryNames = payload.searchItemCategoryNames;
            }else if(payload?.searchItemCategoryNames?.length === 0){
                state.closingStockSummarySearchParams.primaryFilter.searchItemCategoryNames = [];
            }
            if(payload?.searchItemSubCategoryIds && payload?.searchItemSubCategoryIds !== ''){
                state.closingStockSummarySearchParams.primaryFilter.searchItemSubCategoryIds = payload.searchItemSubCategoryIds;
            }else if(payload?.searchItemSubCategoryIds === ''){
                state.closingStockSummarySearchParams.primaryFilter.searchItemSubCategoryIds = '';
            }
            if(payload?.searchItemSubCategoryNames && payload?.searchItemSubCategoryNames?.length > 0){
                state.closingStockSummarySearchParams.primaryFilter.searchItemSubCategoryNames = payload.searchItemSubCategoryNames;
            }else if(payload?.searchItemSubCategoryNames?.length === 0){
                state.closingStockSummarySearchParams.primaryFilter.searchItemSubCategoryNames = [];
            }

            if(payload?.searchBrandIds && payload?.searchBrandIds !== ''){
                state.closingStockSummarySearchParams.primaryFilter.searchBrandIds = payload.searchBrandIds;
            }else if(payload?.searchBrandIds === ''){
                state.closingStockSummarySearchParams.primaryFilter.searchBrandIds = '';
            }
            if(payload?.searchBrandNames && payload?.searchBrandNames?.length > 0){
                state.closingStockSummarySearchParams.primaryFilter.searchBrandNames = payload.searchBrandNames;
            }else if(payload?.searchBrandNames?.length === 0){
                state.closingStockSummarySearchParams.primaryFilter.searchBrandNames = [];
            }
            if(payload?.searchInvItemIds && payload?.searchInvItemIds !== ''){
                state.closingStockSummarySearchParams.primaryFilter.searchInvItemIds = payload.searchInvItemIds;
            }else if(payload?.searchInvItemIds === ''){
                state.closingStockSummarySearchParams.primaryFilter.searchInvItemIds = '';
            }
            if(payload?.searchInvItemNames && payload?.searchInvItemNames?.length > 0){
                state.closingStockSummarySearchParams.primaryFilter.searchInvItemNames = payload.searchInvItemNames;
            }else if(payload?.searchInvItemNames?.length === 0){
                state.closingStockSummarySearchParams.primaryFilter.searchInvItemNames = [];
            }
            
        },
        closingStockSummaryGetData: (state, {payload}) => {
            state.loadClosingStockSummaryData = payload;
        },
        closingStockSummaryLoadingPending: (state) => {
            state.closingStockSummaryLists.isLoading = true;
            state.closingStockSummaryLists.dataLoaded = false;
            state.closingStockSummaryLists.recordCounts = 0;
            state.closingStockSummaryLists.totalRecords = 0;
        },
        closingStockSummaryLoadingSuccess: (state, {payload}) => {
            state.closingStockSummaryLists.isLoading = false;
            state.closingStockSummaryLists.data = payload;
            state.closingStockSummaryLists.closingStockSummaryError = '';
            state.closingStockSummaryLists.dataLoaded = true;
            state.loadClosingStockSummaryData = false;
        },
        closingStockSummaryLoadingFailed: (state, {payload}) => {
            state.closingStockSummaryLists.isLoading = false;
            state.closingStockSummaryLists.data = []
            state.closingStockSummaryLists.closingStockSummaryError = payload;
            state.closingStockSummaryLists.dataLoaded = true;
            state.loadClosingStockSummaryData = false;
        },
        closingStockSummaryLoadMorePending: (state) => {
            state.closingStockSummaryLists.isLoadingMore = true;
        },
        closingStockSummaryLoadMoreSuccess: (state, {payload}) => {
            state.closingStockSummaryLists.isLoadingMore = false;
            state.closingStockSummaryLists.data = state.closingStockSummaryLists.data.concat(payload);
            state.closingStockSummaryLists.jobCardLoadMoreError = '';
        },
        closingStockSummaryLoadMoreFailed: (state, {payload}) => {
            state.closingStockSummaryLists.isLoadingMore = false;
            state.closingStockSummaryLists.jobCardLoadMoreError = payload;
        },
        closingStockSummaryTotalRecordsUpdate: (state, {payload}) => {
            state.closingStockSummaryLists.totalRecords = payload.totalRecords || 0;
            state.closingStockSummaryLists.recordCounts = Number.isInteger(payload.recordCounts) ? (state.closingStockSummaryLists.recordCounts + payload.recordCounts) : 0;
        },
        closingStockSummaryPageNoUpdate: (state, {payload}) => {
            state.closingStockSummaryLists.pageNo = payload;
            state.loadClosingStockSummaryData = true;
        },
        closingStockSummaryPerPageRecordsUpdate: (state, {payload}) => {
            state.closingStockSummaryLists.perPageRecords = payload;
            state.closingStockSummaryLists.pageNo = 0;
            state.loadClosingStockSummaryData = true;
        },
        closingStockSummaryListReset: (state,{payload}) => {
            state.closingStockSummaryLists.isLoading = false;
            state.closingStockSummaryLists.isLoadingMore = false;
            state.closingStockSummaryLists.dataLoaded = false;
            state.closingStockSummaryLists.data = null;
            state.closingStockSummaryLists.totalRecords = 0;
            state.closingStockSummaryLists.recordCounts = 0;
            state.closingStockSummaryLists.pageNo = 0;
            state.closingStockSummaryLists.perPageRecords = 2000;
            state.closingStockSummaryLists.closingStockSummaryError = '';
            state.closingStockSummaryLists.closingStockSummaryMoreError = '';
            state.manageDefectiveandScrap.forItemRow = null;
            state.manageDefectiveandScrap.forBranchId = null;
        },
        closingStockSummaryItemSNWiseToggle: (state, {payload}) => {
            state.closingStockSummarySearchParams.showItemSNWise = payload
        },
        closingStockSummaryDefItemsToggle: (state, {payload}) => {
            state.closingStockSummarySearchParams.showDefItems = payload
        },
        closingStockSummaryRepItemsToggle: (state, {payload}) => {
            state.closingStockSummarySearchParams.showRepItems = payload
        },
        closingStockSummaryScrapitemToggle: (state, {payload}) => {
            state.closingStockSummarySearchParams.showScrapItems = payload
        },
        closingStockSummaryNonTrItemToggle: (state, {payload}) => {
            state.closingStockSummarySearchParams.showOnlyTrItems = payload
        },
        closingStockSummaryActiveItemToggle: (state, {payload}) => {
            state.closingStockSummarySearchParams.showOnlyActiveItems = payload
        },
        closingStockSummaryBranchMappedModelItemsToggle: (state, {payload}) => {
            state.closingStockSummarySearchParams.showOnlyBranchMappedModelItems = payload
        },
        closingStockSummaryManageDefectiveScrap: (state, {payload}) => {
            state.manageDefectiveandScrap.forItemRow = payload.forItemRow;
            state.manageDefectiveandScrap.forBranchId = payload.forBranchId;
        },
    }
});

const { reducer, actions } = reportClosingStockSummarySlice;

export const {
    closingStockSummaryPrimaryFiltersUpdates, closingStockSummaryGetData,
    closingStockSummaryLoadingPending,closingStockSummaryLoadingSuccess,closingStockSummaryLoadingFailed,
    closingStockSummaryLoadMorePending, closingStockSummaryLoadMoreSuccess, closingStockSummaryLoadMoreFailed,
    closingStockSummaryTotalRecordsUpdate, closingStockSummaryPageNoUpdate, closingStockSummaryPerPageRecordsUpdate,
    closingStockSummaryListReset, closingStockSummaryNonTrItemToggle,closingStockSummaryItemSNWiseToggle,closingStockSummaryDefItemsToggle,
    closingStockSummaryRepItemsToggle, closingStockSummaryScrapitemToggle, closingStockSummaryActiveItemToggle, closingStockSummaryBranchMappedModelItemsToggle, closingStockSummaryManageDefectiveScrap
}
    = actions;

export default reducer;